export default __webpack_public_path__ + "static/media/Snd1.173ee8cd.mp3";